import React from "react";
import { createHashRouter } from "react-router-dom";

import { AuthenticationViews } from "./types";

import Authentication from "./Authentication";
import ForgotPassword from "./ForgotPasswordContainer";
import Join from "./JoinContainer";
import JoinSuccess from "./JoinSuccess";
import Login from "./LoginContainer";
import VerifyNonce from "./VerifyNonceContainer";
import SetPassword from "./SetPasswordContainer";
import EnableMfa from "./EnableMfaContainer";
import RecoveryCodes from "./RecoveryCodesContainer";
import VerifyMfa from "./VerifyMfaContainer";
import AddPasskey from "./AddPasskeyContainer";
import AddTotp from "./AddTotpContainer";
import Mfa from "./MfaContainer";

export const AuthenticationRouter = createHashRouter([
    {
        path: "/",
        element: <Authentication />,
        children: [
            {
                path: AuthenticationViews.join,
                element: <Join />,
            },
            {
                path: AuthenticationViews.joinSuccess,
                element: <JoinSuccess />,
            },
            {
                path: AuthenticationViews.login,
                element: <Login />,
            },
            {
                path: AuthenticationViews.verifyPasswordInitNonce,
                element: <VerifyNonce />,
            },
            {
                path: AuthenticationViews.initializePassword,
                element: <SetPassword />,
            },
            {
                path: AuthenticationViews.forgotPassword,
                element: <ForgotPassword />,
            },
            {
                path: AuthenticationViews.verifyPasswordResetNonce,
                element: <VerifyNonce />,
            },
            {
                path: AuthenticationViews.resetPassword,
                element: <SetPassword />,
            },
            {
                path: AuthenticationViews.enableMfa,
                element: <EnableMfa />,
            },
            {
                path: AuthenticationViews.recoveryCodes,
                element: <RecoveryCodes />,
            },
            {
                path: AuthenticationViews.verifyMfa,
                element: <VerifyMfa />,
            },
            {
                path: AuthenticationViews.addPasskey,
                element: <AddPasskey />,
            },
            {
                path: AuthenticationViews.addTotp,
                element: <AddTotp />,
            },
            {
                path: "",
                element: <Login />,
            },
        ],
    },
]);

export const MfaRouter = createHashRouter([
    {
        path: "/",
        element: <Authentication />,
        children: [
            {
                path: AuthenticationViews.enableMfa,
                element: <EnableMfa />,
            },
            {
                path: AuthenticationViews.recoveryCodes,
                element: <RecoveryCodes />,
            },
            {
                path: AuthenticationViews.verifyMfa,
                element: <VerifyMfa />,
            },
            {
                path: AuthenticationViews.addPasskey,
                element: <AddPasskey />,
            },
            {
                path: AuthenticationViews.addTotp,
                element: <AddTotp />,
            },
            {
                path: AuthenticationViews.mfa,
                element: <Mfa />,
            },
            {
                path: "",
                element: <Mfa />,
            },
        ],
    },
]);
export const JoinRouter = createHashRouter([
    {
        path: "/",
        element: <Authentication />,
        children: [
            {
                path: AuthenticationViews.join,
                element: <Join />,
            },
            {
                path: AuthenticationViews.joinSuccess,
                element: <JoinSuccess />,
            },
            {
                path: "",
                element: <Join />,
            },
        ],
    },
]);
